import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

/** Reads tenant.brand_color/accent_color and applies them to CSS variables
 *  consumed across the ERP UI. Also tints favicon/title with tenant name. */
export default function TenantThemeProvider({ children }) {
  const { tenant } = useAuth();

  useEffect(() => {
    if (!tenant) return;
    const root = document.documentElement;
    if (tenant.brand_color) root.style.setProperty("--tenant-brand", tenant.brand_color);
    if (tenant.accent_color) root.style.setProperty("--tenant-accent", tenant.accent_color);
    if (tenant.name) document.title = `${tenant.name} · Gr8Boost ERP`;
  }, [tenant]);

  return children;
}
